import { createFileRoute, Outlet } from "@tanstack/react-router";

import { requireSection } from "@/shared/auth/access";

/** The money: the wallets, the top-ups, the ledger. One guard for all. */
export const Route = createFileRoute("/_app/money")({
  beforeLoad: ({ context }) => {
    requireSection(context.role, "money");
  },
  component: Outlet,
});
